export function Preloader() {
  return (
    <div className="preloader" id="preloader">
      <div className="preloader__mark">
        <img src="/assets/img/marca-skyenex.webp" alt="" width={256} height={256} />
      </div>
      <div className="preloader__bar"><i /></div>
    </div>
  )
}
